import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table table-responsive-sm table-bordered table-striped table-sm" }
const _hoisted_6 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", null, "대표 이미지"),
    /*#__PURE__*/_createVNode("th", null, "제목"),
    /*#__PURE__*/_createVNode("th", null, "하위 제목"),
    /*#__PURE__*/_createVNode("th", null, "설정")
  ])
], -1)
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = /*#__PURE__*/_createVNode("svg", { class: "c-icon c-icon-lg" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-trash" })
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("svg", { class: "c-icon c-icon-lg" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-pencil" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationV2 = _resolveComponent("PaginationV2")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: ["card", { loading: _ctx.loading }]
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("button", {
            class: "btn btn-primary align-bottom mb-3",
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addRecord()))
          }, " 카테고리 등록 "),
          _createVNode("div", _hoisted_4, [
            _createVNode("table", _hoisted_5, [
              _hoisted_6,
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: category.id
                  }, [
                    _createVNode("td", _hoisted_7, [
                      _createVNode("img", {
                        src: category.thumbnail_phone,
                        height: "50"
                      }, null, 8, ["src"])
                    ]),
                    _createVNode("td", null, _toDisplayString(category.name), 1),
                    _createVNode("td", null, _toDisplayString(category.sub_name), 1),
                    _createVNode("td", null, [
                      _createVNode("button", {
                        class: "btn btn-btn-warning",
                        disabled: _ctx.loading,
                        type: "button",
                        onClick: ($event: any) => (_ctx.deleteRecord(category.id))
                      }, [
                        _createVNode("span", {
                          class: { 'text-danger': !_ctx.loading }
                        }, [
                          _hoisted_8
                        ], 2)
                      ], 8, ["disabled", "onClick"]),
                      _createVNode("button", {
                        class: "btn btn-btn-warning",
                        disabled: _ctx.loading,
                        type: "button",
                        onClick: ($event: any) => (_ctx.editRecord(category.id))
                      }, [
                        _createVNode("span", {
                          class: { 'text-danger': !_ctx.loading }
                        }, [
                          _hoisted_9
                        ], 2)
                      ], 8, ["disabled", "onClick"])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createVNode(_component_PaginationV2, {
            "data-model": _ctx.CrudModel,
            "order-options": _ctx.orderOptions,
            "filter-conditions": _ctx.filterConditions,
            onDataChanged: _ctx.updateData,
            onIsLoading: _ctx.isLoading,
            limit: _ctx.perpage
          }, null, 8, ["data-model", "order-options", "filter-conditions", "onDataChanged", "onIsLoading", "limit"])
        ])
      ], 2)
    ])
  ]))
}